import type { ReactNode } from "react";

export type BulkAction = { key: string; label: string; icon?: ReactNode; onClick: () => void; danger?: boolean };

/** Sticky action bar shown while rows are selected. Destructive actions are last and red. */
export function BulkBar({ count, noun, actions, onClear, busy, total, onSelectAll }: { count: number; noun: string; actions: BulkAction[]; onClear: () => void; busy?: boolean; total?: number; onSelectAll?: () => void }) {
  if (count === 0) return null;
  const ordered = [...actions.filter((a) => !a.danger), ...actions.filter((a) => a.danger)];
  return (
    <div
      role="toolbar"
      aria-label={`Actions for ${count} selected ${noun}`}
      className="glass-overlay sticky bottom-3 z-20 mx-auto flex w-full flex-wrap items-center gap-2 rounded-tile border border-border p-2.5 shadow-lg"
    >
      <span className="px-2 text-sm font-semibold text-foreground">{count} selected</span>
      {onSelectAll && total != null && total > count && (
        <button type="button" onClick={onSelectAll} className="min-h-9 rounded-btn px-2 text-sm font-semibold text-primary hover:underline">
          Select all {total}
        </button>
      )}
      <div className="flex flex-1 flex-wrap items-center gap-1.5">
        {ordered.map((a) => (
          <button
            key={a.key}
            type="button"
            disabled={busy}
            onClick={a.onClick}
            className={`inline-flex min-h-9 items-center gap-1.5 rounded-btn border px-3 text-sm font-semibold transition disabled:opacity-50 focus-visible:ring-2 ring-ring ${
              a.danger
                ? "border-destructive/30 text-destructive hover:bg-destructive/10"
                : "border-border bg-card text-foreground hover:bg-secondary"
            }`}
          >
            {a.icon}
            {a.label}
          </button>
        ))}
      </div>
      <button type="button" onClick={onClear} className="px-2 text-sm font-semibold text-muted-foreground hover:text-foreground">
        Clear
      </button>
    </div>
  );
}
